import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _awaitAsyncGenerator from "@babel/runtime/helpers/awaitAsyncGenerator";
import _wrapAsyncGenerator from "@babel/runtime/helpers/wrapAsyncGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var n = r.done; return Promise.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(r) { var n = this.s.return; return void 0 === n ? Promise.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, throw: function _throw(r) { var n = this.s.return; return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); }
/**
 * @fileOverview Implements a fetch function that can handle multipart/mixed responses.
 * The multipart response is expected to follow the GraphQL multipart request spec.
 *
 * See https://github.com/graphql/graphql-over-http/blob/main/rfcs/IncrementalDelivery.md#content-type-multipartmixed
 * See https://github.com/graphql/graphql-over-http/blob/main/spec/GraphQLOverHTTP.md#multipart-request-format
 */
import merge from 'lodash/merge';
import { Observable } from 'relay-runtime';
import { fg } from '@atlaskit/platform-feature-flags';
import { RelayExperimentalApis } from '@atlassian/relay-experimental-apis';
var NO_CONTENT = 204;
function getBoundary(contentType) {
  var parts = contentType.split('boundary=');
  if (parts.length < 2) {
    return null;
  }
  return parts[1].trim();
}
function processChunk(chunk, boundaryString, observer) {
  var parts = chunk.split(boundaryString);
  var incompleteChunk = '';

  // Process all complete parts (except the last one which might be incomplete)
  for (var i = 0; i < parts.length - 1; i++) {
    var part = parts[i].trim();

    // Skip empty parts and encapsulation boundaries
    if (part && !part.startsWith('--')) {
      // Split content-type header and body
      var _part$split = part.split(/\r?\n\r?\n/),
        _part$split2 = _slicedToArray(_part$split, 2),
        part1 = _part$split2[0],
        part2 = _part$split2[1];

      // when response content has boundary string, part1 is the actual response
      // when response content does not have boundary string, part2 is the actual response
      var body = part2 !== null && part2 !== void 0 ? part2 : part1;
      if (body) {
        try {
          var jsonData = JSON.parse(incompleteChunk + body);
          observer.next(jsonData);
          incompleteChunk = '';
        } catch (error) {
          // add boundary string back to response for cases when response content has boundary string
          // no error is thrown because next part might be a valid JSON object
          incompleteChunk += body + boundaryString;
        }
      }
    }
  }

  // Return the last part which might be incomplete
  return incompleteChunk + parts[parts.length - 1];
}
export function processStream(_x, _x2, _x3) {
  return _processStream.apply(this, arguments);
}
function _processStream() {
  _processStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(reader, boundary, observer) {
    var boundaryString, incompleteChunk, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, newText, combinedChunk;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          boundaryString = "--".concat(boundary);
          incompleteChunk = ''; // Process chunks until the stream is done
          _iteratorAbruptCompletion = false;
          _didIteratorError = false;
          _context2.prev = 4;
          _iterator = _asyncIterator(reader);
        case 6:
          _context2.next = 8;
          return _iterator.next();
        case 8:
          if (!(_iteratorAbruptCompletion = !(_step = _context2.sent).done)) {
            _context2.next = 15;
            break;
          }
          newText = _step.value;
          combinedChunk = incompleteChunk + newText; // Process the combined chunk and get any incomplete part
          incompleteChunk = processChunk(combinedChunk, boundaryString, observer);
        case 12:
          _iteratorAbruptCompletion = false;
          _context2.next = 6;
          break;
        case 15:
          _context2.next = 21;
          break;
        case 17:
          _context2.prev = 17;
          _context2.t0 = _context2["catch"](4);
          _didIteratorError = true;
          _iteratorError = _context2.t0;
        case 21:
          _context2.prev = 21;
          _context2.prev = 22;
          if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
            _context2.next = 26;
            break;
          }
          _context2.next = 26;
          return _iterator.return();
        case 26:
          _context2.prev = 26;
          if (!_didIteratorError) {
            _context2.next = 29;
            break;
          }
          throw _iteratorError;
        case 29:
          return _context2.finish(26);
        case 30:
          return _context2.finish(21);
        case 31:
          // Process any remaining data
          if (incompleteChunk.length > 0) {
            processChunk(incompleteChunk, boundaryString, observer);
          }
          observer.complete();
        case 33:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[4, 17, 21, 31], [22,, 26, 30]]);
  }));
  return _processStream.apply(this, arguments);
}
function handleMultipartResponse(response, observer) {
  var contentType = response.headers.get('content-type');
  var boundary = getBoundary(contentType || '');
  if (!boundary) {
    observer.error(new Error('Invalid multipart boundary'));
    return;
  }
  var decoder = new TextDecoder('utf-8');
  function streamReader() {
    return _streamReader.apply(this, arguments);
  }
  function _streamReader() {
    _streamReader = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, chunk, newText;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // @ts-expect-error a Response object in Node is streamable
            _iteratorAbruptCompletion2 = false;
            _didIteratorError2 = false;
            _context.prev = 2;
            _iterator2 = _asyncIterator(response.body);
          case 4:
            _context.next = 6;
            return _awaitAsyncGenerator(_iterator2.next());
          case 6:
            if (!(_iteratorAbruptCompletion2 = !(_step2 = _context.sent).done)) {
              _context.next = 14;
              break;
            }
            chunk = _step2.value;
            newText = decoder.decode(chunk, {
              stream: true
            });
            _context.next = 11;
            return newText;
          case 11:
            _iteratorAbruptCompletion2 = false;
            _context.next = 4;
            break;
          case 14:
            _context.next = 20;
            break;
          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](2);
            _didIteratorError2 = true;
            _iteratorError2 = _context.t0;
          case 20:
            _context.prev = 20;
            _context.prev = 21;
            if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
              _context.next = 25;
              break;
            }
            _context.next = 25;
            return _awaitAsyncGenerator(_iterator2.return());
          case 25:
            _context.prev = 25;
            if (!_didIteratorError2) {
              _context.next = 28;
              break;
            }
            throw _iteratorError2;
          case 28:
            return _context.finish(25);
          case 29:
            return _context.finish(20);
          case 30:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 16, 20, 30], [21,, 25, 29]]);
    }));
    return _streamReader.apply(this, arguments);
  }
  try {
    // Depending on the version of Node we're running in, the Response object may not implement ReadableStream.
    // Here, we treat the response as an async iterator, since both node-fetch and browser implement the response body as a stream.
    // We wrap that iteration in an async generator, which lets us
    processStream(streamReader(), boundary, observer).catch(function (error) {
      return observer.error(error);
    });
  } catch (e) {
    var error = new Error('Failed to read from response body');
    // @ts-ignore: cause property may not be available in all environments
    error.cause = e;
    observer.error(error);
  }
}
function handleJsonResponse(response, observer) {
  response.json().then(function (data) {
    return observer.next(data);
  }).catch(function (error) {
    return observer.error(error);
  }).finally(function () {
    return observer.complete();
  });
}
function handleTextResponse(response, observer) {
  response.text().then(function (data) {
    var maybeJson = data ? JSON.parse(data) : null;
    observer.next(maybeJson);
    observer.complete();
  }).catch(function (error) {
    var _response$headers;
    observer.error(new Error("Error while parsing text response (Content-Type: ".concat(response === null || response === void 0 || (_response$headers = response.headers) === null || _response$headers === void 0 ? void 0 : _response$headers.get('content-type'), "): ").concat(error instanceof Error ? error.message : String(error))));
  });
}
function processMultipartPromise(source) {
  // Cache the result of the source promise to avoid calling it multiple times.
  var result = source();
  // Wrap an observer around the result to handle the response.
  return Observable.create(function (observer) {
    result.then(function (response) {
      if (response.status === NO_CONTENT) {
        observer.complete();
        return;
      }
      var contentType = response.headers.get('content-type') || '';
      if (contentType.includes('application/json') || contentType.includes('application/graphql-response+json')) {
        handleJsonResponse(response, observer);
      } else if (contentType.includes('text/plain')) {
        handleTextResponse(response, observer);
      } else if (contentType.includes('multipart/mixed')) {
        handleMultipartResponse(response, observer);
      } else {
        handleTextResponse(response, observer);
      }
    }).catch(function (error) {
      return observer.error(error);
    });
  });
}
var relayDeferAcceptableFormats = ['application/graphql-response+json', 'application/json',
// there must not be spacing between `multipart/mixed` and `deferSpec=20220824` since the backend assumes no spacing
'multipart/mixed;deferSpec=20220824'];
var MAX_QUERY_LENGTH = 2000; // Maximum allowed query length
var MAX_HEADERS_SIZE = 20 * 1024; // Maximum header size in bytes (20 KB)

// Calculate the size of the headers
function calculateHeadersSize(headers) {
  var totalBytes = 0;
  var textEncoder = new TextEncoder();

  // Iterate over each header entry (name and value)
  for (var _i = 0, _Object$entries = Object.entries(headers); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      name = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    var headerSize = textEncoder.encode("".concat(name, ": ").concat(value, "\r\n")).length; // Include CRLF
    totalBytes += headerSize;
  }
  return totalBytes;
}
function shouldUseGetMethod(_ref) {
  var url = _ref.url,
    variables = _ref.variables,
    request = _ref.request,
    headers = _ref.headers,
    isServer = _ref.isServer;
  if (isServer) {
    return {
      isGetRequest: false,
      reason: 'SSR'
    };
  }
  if (request.operationKind !== 'query') {
    return {
      isGetRequest: false,
      reason: request.operationKind
    };
  }
  var serializedVariables = JSON.stringify(variables);
  var queryLength = url.length + serializedVariables.length;
  var headersSize = calculateHeadersSize(headers || {});
  return queryLength <= MAX_QUERY_LENGTH && headersSize <= MAX_HEADERS_SIZE ? {
    isGetRequest: true
  } : {
    isGetRequest: false,
    reason: 'URL length or headers size too large'
  };
}
function buildGraphqlSmartFetch(_ref2) {
  var _cacheConfig$metadata;
  var url = _ref2.url,
    options = _ref2.options,
    variables = _ref2.variables,
    request = _ref2.request,
    isServer = _ref2.isServer,
    cacheConfig = _ref2.cacheConfig;
  var headers = _objectSpread({
    'atl-client-name': 'atlassian-frontend-monorepo',
    Accept: relayDeferAcceptableFormats.join(', '),
    'X-ExperimentalApi': RelayExperimentalApis.join(',')
  }, (cacheConfig === null || cacheConfig === void 0 || (_cacheConfig$metadata = cacheConfig.metadata) === null || _cacheConfig$metadata === void 0 ? void 0 : _cacheConfig$metadata.headers) || {});
  var requestOptions = merge(options, _objectSpread(_objectSpread({}, fg('add_credential_option_for_all_agg_requests') ? {
    credentials: 'same-origin'
  } : {}), {}, {
    headers: headers
  }));
  requestOptions.headers['Content-Type'] = 'application/json';
  var _shouldUseGetMethod = shouldUseGetMethod({
      url: url,
      variables: variables,
      request: request,
      headers: requestOptions.headers,
      isServer: isServer
    }),
    isGetRequest = _shouldUseGetMethod.isGetRequest,
    reason = _shouldUseGetMethod.reason;

  // Nav4ProjectsContentQuery is forced to go POST route to avoid the stale cache issues when transition between issues in Issue-view
  // that's not a permanent fix, but rather an attampt to unblock the team
  // Context: #jiv-navigation-issue channel
  if (isGetRequest && request.name !== 'Nav4ProjectsContentQuery') {
    requestOptions.method = 'GET';
    var params = new URLSearchParams();
    params.append('variables', JSON.stringify(variables));
    url += "".concat(url.includes('?') ? '&' : '?').concat(params.toString());
    delete requestOptions.body; // Not needed for GET
  } else {
    requestOptions.method = 'POST';
    if (reason) {
      requestOptions.headers['X-Request-Fallback-To-Post-Reason'] = reason;
    }
  }
  return function () {
    return fetch(url, requestOptions);
  };
}
export { buildGraphqlSmartFetch, processChunk,
// These are only exported for testing purposes.
processMultipartPromise, calculateHeadersSize, shouldUseGetMethod };